import MuiAlert, { AlertColor } from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import * as React from 'react'

import StackContext from '../contexts/stackContext'

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

export interface ToastProps {
  message: string
  toastId: string
  severity: AlertColor
  autoHideDuration: number | undefined
}

export default function Toast(props: ToastProps) {
  const { autoHideDuration, toastId } = props
  const stack = React.useContext(StackContext)
  const [open, setOpen] = React.useState(true)
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
    stack.setToasts((stack) => stack.filter((toast) => toast.props.toastId !== toastId))
  }

  return (
    <React.Fragment>
      <Snackbar
        open={open}
        {...(autoHideDuration ? { autoHideDuration } : {})}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ width: '50%', minWidth: '400px' }}
        style={{ zIndex: 99999, position: 'relative' }}
      >
        <Alert onClose={handleClose} sx={{ width: '100%' }} severity={props.severity}>
          {props.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  )
}
